var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-edit',_vm._g(_vm._b({attrs:{"title":`Abonnement auf ${_vm.subscription.title} ändern`,"name":"settings-payment-subscription-update"}},'base-edit',_vm.$attrs,false),_vm.$listeners),[_c('SettingsPaymentSubscriptionForm',{attrs:{"type":"update","subscription":_vm.subscription}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }